import { render } from "./TrainingViewer.vue?vue&type=template&id=bef0407a"
import script from "./TrainingViewer.vue?vue&type=script&lang=js"
export * from "./TrainingViewer.vue?vue&type=script&lang=js"

import "./TrainingViewer.vue?vue&type=style&index=0&id=bef0407a&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__